(function () {
  const app = document.querySelector('[data-catalogo-dashboard]');
  if (!app) return;

  const ELS_CATALOG_RULES = {
    requiredFields: ['title', 'sku', 'vendor', 'price'],
    professionalTags: ['brand_revivre', 'brand_cpm', 'preordine', 'professionale'],
    preorderTags: ['preordine'],
    allowedVendors: ['Revivre', 'Flosé', 'Flose', 'Ysothea', 'CPM', 'Donald', 'Polyflame', 'Take Care', 'ELS'],
    statusActiveValues: ['active', 'true', 'published', 'matched'],
    priceWarnings: {
      maxDecimalPlaces: 2,
      highPrice: 1000
    },
    warnings: {
      missingImage: true,
      missingSku: true,
      missingPrice: true,
      missingProfessionalTag: true,
      unknownVendor: true,
      duplicateSku: true
    }
  };

  const ELS_PREIMPORT_RULES = {
    requiredFields: ['Title', 'Variant SKU', 'Variant Price', 'Vendor'],
    titleField: 'Title',
    skuField: 'Variant SKU',
    priceField: 'Variant Price',
    vendorField: 'Vendor',
    imageField: 'Image Src',
    tagField: 'Tags',
    preorderTag: 'preordine',
    defaultPreorder: true,
    requiredTags: [],
    allowedVendors: ['Revivre', 'Flosé', 'Flose', 'Ysothea', 'CPM', 'Donald', 'Polyflame', 'Take Care', 'ELS'],
    blockingErrors: ['missing_sku', 'missing_title', 'missing_price', 'duplicate_sku'],
    priceWarnings: {
      maxDecimalPlaces: 2,
      highPrice: 1000,
      normalizeExport: true
    },
    preorderRules: [
      { type: 'tag_contains', value: 'no_preordine', suggest: false },
      { type: 'tag_contains', value: 'preordine', suggest: true }
    ],
    warnings: ['missing_image', 'unknown_vendor', 'duplicate_title']
  };

  const ELS_CSV_COLUMN_ALIASES = {
    Title: ['title', 'nome prodotto', 'prodotto', 'descrizione', 'description', 'licence / description', 'licence description', 'denominazione', 'articolo descrizione'],
    'Variant SKU': ['variant sku', 'sku', 'codice', 'codice articolo', 'cod.', 'article', 'ref', 'referenza', 'product code', 'codice prodotto'],
    'Variant Price': ['variant price', 'prezzo', 'prezzo listino', 'prezzo netto', 'prezzo vendita', 'price', 'pvc ttc a partir de', 'pvc ttcà partir de', 'pvc ttc partir de', 'pvc ttc'],
    'Cost per item': ['cost per item', 'costo', 'costo fornitore', 'tarif ht par produit', 'tarif htpar produit', 'tarif ht', 'tariffa ht'],
    Vendor: ['vendor', 'fornitore', 'brand', 'marchio', 'marca', 'produttore', 'supplier'],
    'Image Src': ['image src', 'immagine', 'url immagine', 'image', 'image url', 'link immagine', 'foto', 'photo', 'media'],
    Tags: ['tags', 'tag', 'categoria', 'categorie', 'catégorie', 'categori', 'linea', 'famiglia', 'collezione', 'area', 'tipologia']
  };

  const ELS_COMPARE_RULES = {
    keyField: 'sku',
    priceTolerance: 0.01,
    exportHeaders: [
      'ELS Stato',
      'SKU',
      'Titolo shop',
      'Titolo listino',
      'Vendor shop',
      'Vendor listino',
      'Prezzo shop',
      'Prezzo listino',
      'Azione suggerita',
      'Commento operativo',
      'Note'
    ]
  };

  const state = {
    catalogProducts: [],
    catalogFiltered: [],
    csvHeaders: [],
    csvRows: [],
    csvValidated: [],
    csvSourceName: '',
    csvDelimiter: ',',
    compareHeaders: [],
    compareRows: [],
    compareReport: [],
    compareFiltered: [],
    catalogPlan: null,
    governance: {
      registry: null,
      overrides: null,
      reviewQueue: null,
      familyIndex: [],
      productMap: new Map(),
      loadState: 'pending'
    }
  };

  const els = {
    sourceState: app.querySelector('[data-dashboard-source-state]'),
    tabs: Array.from(app.querySelectorAll('[data-dashboard-tab]')),
    views: Array.from(app.querySelectorAll('[data-dashboard-view]')),
    catalogStats: app.querySelector('[data-catalog-stats]'),
    governanceStats: app.querySelector('[data-governance-stats]'),
    catalogBody: app.querySelector('[data-catalog-table-body]'),
    catalogSearch: app.querySelector('[data-catalog-search]'),
    catalogVendor: app.querySelector('[data-catalog-vendor-filter]'),
    catalogTag: app.querySelector('[data-catalog-tag-filter]'),
    catalogIssue: app.querySelector('[data-catalog-issue-filter]'),
    csvDropzone: app.querySelector('[data-csv-dropzone]'),
    csvFile: app.querySelector('[data-csv-file]'),
    csvStats: app.querySelector('[data-csv-stats]'),
    csvBody: app.querySelector('[data-csv-table-body]'),
    exportClean: app.querySelector('[data-export-clean]'),
    exportErrors: app.querySelector('[data-export-errors]'),
    clearCsv: app.querySelector('[data-clear-csv]'),
    compareDropzone: app.querySelector('[data-compare-dropzone]'),
    compareFile: app.querySelector('[data-compare-file]'),
    compareStats: app.querySelector('[data-compare-stats]'),
    compareBody: app.querySelector('[data-compare-table-body]'),
    compareSearch: app.querySelector('[data-compare-search]'),
    compareStatus: app.querySelector('[data-compare-status-filter]'),
    compareVendor: app.querySelector('[data-compare-vendor-filter]'),
    compareIssue: app.querySelector('[data-compare-issue-filter]'),
    exportCompare: app.querySelector('[data-export-compare]'),
    exportCompareCreate: app.querySelector('[data-export-compare-create]'),
    exportCompareUpdate: app.querySelector('[data-export-compare-update]'),
    exportCompareOnlyShop: app.querySelector('[data-export-compare-only-shop]'),
    clearCompare: app.querySelector('[data-clear-compare]'),
    catalogWorkerUrl: app.querySelector('[data-catalog-worker-url]'),
    catalogWorkerSecret: app.querySelector('[data-catalog-worker-secret]'),
    catalogWorkerPlan: app.querySelector('[data-catalog-worker-plan]'),
    catalogWorkerStatus: app.querySelector('[data-catalog-worker-status]'),
    exportCatalogPlan: app.querySelector('[data-export-catalog-plan]')
  };

  init();

  function init() {
    bindTabs();
    bindCatalogFilters();
    bindCsvControls();
    bindCompareControls();
    loadCatalogData();
  }

  function bindTabs() {
    els.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-dashboard-tab');
        els.tabs.forEach((item) => item.classList.toggle('is-active', item === tab));
        const selectedView = els.views.find((view) => view.getAttribute('data-dashboard-view') === id) || null;
        els.views.forEach((view) => {
          view.classList.toggle('is-active', view.getAttribute('data-dashboard-view') === id);
        });
        if (selectedView && typeof selectedView.scrollIntoView === 'function') {
          window.requestAnimationFrame(() => {
            selectedView.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
      });
    });
  }

  function bindCatalogFilters() {
    [els.catalogSearch, els.catalogVendor, els.catalogTag, els.catalogIssue].forEach((input) => {
      if (!input) return;
      input.addEventListener('input', renderCatalog);
      input.addEventListener('change', renderCatalog);
    });
  }

  function bindCsvControls() {
    if (els.csvFile) {
      els.csvFile.addEventListener('change', (event) => {
        const file = event.target.files && event.target.files[0];
        if (file) readCsvFile(file);
      });
    }

    if (els.csvDropzone) {
      ['dragenter', 'dragover'].forEach((eventName) => {
        els.csvDropzone.addEventListener(eventName, (event) => {
          event.preventDefault();
          els.csvDropzone.classList.add('is-dragging');
        });
      });
      ['dragleave', 'drop'].forEach((eventName) => {
        els.csvDropzone.addEventListener(eventName, (event) => {
          event.preventDefault();
          els.csvDropzone.classList.remove('is-dragging');
        });
      });
      els.csvDropzone.addEventListener('drop', (event) => {
        const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (file) readCsvFile(file);
      });
    }

    els.exportClean?.addEventListener('click', exportCleanCsv);
    els.exportErrors?.addEventListener('click', exportIssuesCsv);
    els.clearCsv?.addEventListener('click', clearCsvState);
  }

  function bindCompareControls() {
    if (els.compareFile) {
      els.compareFile.addEventListener('change', (event) => {
        const file = event.target.files && event.target.files[0];
        if (file) readCompareFile(file);
      });
    }

    if (els.compareDropzone) {
      ['dragenter', 'dragover'].forEach((eventName) => {
        els.compareDropzone.addEventListener(eventName, (event) => {
          event.preventDefault();
          els.compareDropzone.classList.add('is-dragging');
        });
      });
      ['dragleave', 'drop'].forEach((eventName) => {
        els.compareDropzone.addEventListener(eventName, (event) => {
          event.preventDefault();
          els.compareDropzone.classList.remove('is-dragging');
        });
      });
      els.compareDropzone.addEventListener('drop', (event) => {
        const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (file) readCompareFile(file);
      });
    }

    els.exportCompare?.addEventListener('click', exportCompareCsv);
    els.exportCompareCreate?.addEventListener('click', () => exportCompareSubset('create'));
    els.exportCompareUpdate?.addEventListener('click', () => exportCompareSubset('update'));
    els.exportCompareOnlyShop?.addEventListener('click', () => exportCompareSubset('only_shop'));
    els.clearCompare?.addEventListener('click', clearCompareState);
    els.catalogWorkerPlan?.addEventListener('click', runCatalogWorkerPlan);
    els.exportCatalogPlan?.addEventListener('click', exportCatalogPlanCsv);

    [els.compareSearch, els.compareStatus, els.compareVendor, els.compareIssue].forEach((input) => {
      if (!input) return;
      input.addEventListener('input', renderCompare);
      input.addEventListener('change', renderCompare);
    });

    [els.catalogWorkerUrl, els.catalogWorkerSecret].forEach((input) => {
      if (!input) return;
      input.addEventListener('input', updateCatalogWorkerControls);
      input.addEventListener('change', updateCatalogWorkerControls);
    });
  }

  async function loadCatalogData() {
    const listinoUrl = app.getAttribute('data-listino-json-url');
    const sampleUrl = app.getAttribute('data-catalog-json-url');

    await loadGovernanceData();

    try {
      const listinoResponse = await fetch(listinoUrl);
      if (!listinoResponse.ok) throw new Error('Listino non disponibile');
      const listino = await listinoResponse.json();
      state.catalogProducts = flattenListinoProducts(listino);
      setSourceState(buildSourceState('listino-preordine.json'));
    } catch (error) {
      try {
        const sampleResponse = await fetch(sampleUrl);
        if (!sampleResponse.ok) throw new Error('Sample non disponibile');
        const sample = await sampleResponse.json();
        state.catalogProducts = normalizeCatalogProducts(sample.products || []);
        setSourceState(buildSourceState('sample JSON'));
      } catch (sampleError) {
        state.catalogProducts = [];
        setSourceState('Fonte dati: non disponibile');
      }
    }

    classifyCatalogProducts();
    populateVendorFilter();
    renderCatalog();
    if (state.compareRows.length) buildAndRenderCompare();
  }

  async function loadGovernanceData() {
    const registryUrl = app.getAttribute('data-governance-registry-url');
    const overridesUrl = app.getAttribute('data-governance-overrides-url');
    const reviewUrl = app.getAttribute('data-governance-review-url');

    if (!registryUrl) {
      state.governance.loadState = 'missing';
      return;
    }

    try {
      const [registry, overrides, reviewQueue] = await Promise.all([
        fetchJson(registryUrl),
        overridesUrl ? fetchJson(overridesUrl).catch(() => null) : Promise.resolve(null),
        reviewUrl ? fetchJson(reviewUrl).catch(() => null) : Promise.resolve(null)
      ]);
      state.governance.registry = registry;
      state.governance.overrides = overrides || { overrides: [] };
      state.governance.reviewQueue = reviewQueue || { items: [] };
      state.governance.familyIndex = buildGovernanceFamilyIndex(registry);
      state.governance.loadState = 'ready';
    } catch (error) {
      state.governance.registry = null;
      state.governance.overrides = { overrides: [] };
      state.governance.reviewQueue = { items: [] };
      state.governance.familyIndex = [];
      state.governance.loadState = 'error';
    }
  }

  async function fetchJson(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  }

  function flattenListinoProducts(listino) {
    const products = [];
    (listino.collections || []).forEach((collection) => {
      (collection.linee || []).forEach((line) => {
        (line.prodotti || []).forEach((product) => {
          products.push({
            title: product.nome || product.shopify_product_title || '',
            sku: product.sku || product.codice || '',
            vendor: product.venditore || '',
            rawPrice: product.prezzo,
            price: product.prezzo,
            status: product.shopify_published ? 'active' : (product.shopify_status || ''),
            tags: [product.venditore ? `brand_${slugify(product.venditore)}` : '', collection.collezione, line.linea].filter(Boolean),
            image: Boolean(product.image || product.immagine || product.image_src),
            preorder: true,
            line: line.linea || product.linea || '',
            collection: collection.collezione || product.collezione || '',
            source: product.sorgente || 'listino-preordine'
          });
        });
      });
    });
    return normalizeCatalogProducts(products);
  }

  function normalizeCatalogProducts(products) {
    return products.map((product) => ({
      title: String(product.title || product.nome || '').trim(),
      sku: String(product.sku || product.codice || '').trim(),
      vendor: String(product.vendor || product.venditore || '').trim(),
      rawPrice: product.rawPrice ?? product.price ?? product.prezzo,
      price: parsePrice(product.price ?? product.prezzo),
      status: String(product.status || product.shopify_status || '').trim(),
      tags: normalizeTags(product.tags),
      image: Boolean(product.image || product.image_src || product.immagine),
      preorder: Boolean(product.preorder),
      line: String(product.line || product.linea || '').trim(),
      collection: String(product.collection || product.collezione || '').trim(),
      source: String(product.source || product.sorgente || '').trim()
    }));
  }

  function buildGovernanceFamilyIndex(registry) {
    return (registry?.families || []).map((family) => ({
      family,
      familyKey: normalizeKey(family.display_name),
      supplierKeys: (family.match_rules?.vendor || [family.supplier]).map(normalizeKey).filter(Boolean),
      aliasKeys: uniqueKeys([
        family.display_name,
        ...(family.aliases || []),
        ...(family.lines || []).flatMap((line) => [line.display_name, ...(line.aliases || [])]),
        ...(family.match_rules?.title_contains || []),
        ...(family.match_rules?.line_contains || []),
        ...(family.match_rules?.collection_contains || []),
        ...(family.match_rules?.tag_contains || [])
      ])
    }));
  }

  function classifyCatalogProducts() {
    state.governance.productMap = new Map();
    state.catalogProducts.forEach((product) => {
      state.governance.productMap.set(product, classifyProductGovernance(product));
    });
  }

  function classifyProductGovernance(product) {
    if (state.governance.loadState !== 'ready') {
      return {
        status: 'registry_missing',
        label: 'Registry assente',
        family: '',
        area: '',
        source: 'none',
        confidence: 0
      };
    }

    const override = findGovernanceOverride(product);
    if (override) {
      return {
        status: 'manual_override',
        label: 'Override manuale',
        family: override.family_id || override.family || '',
        area: override.area || '',
        source: 'manual_override',
        confidence: 1,
        owner: override.owner || ''
      };
    }

    const matches = state.governance.familyIndex
      .map((entry) => scoreGovernanceFamily(product, entry))
      .filter((match) => match.score > 0)
      .sort((a, b) => b.score - a.score);

    if (!matches.length) {
      return {
        status: 'unclassified',
        label: 'Non classificato',
        family: '',
        area: '',
        source: 'registry',
        confidence: 0
      };
    }

    const best = matches[0];
    const second = matches[1];
    if (second && second.score === best.score) {
      return {
        status: 'ambiguous',
        label: 'Ambiguo',
        family: `${best.family.display_name} / ${second.family.display_name}`,
        area: '',
        source: 'registry',
        confidence: Math.min(best.score / 5, 0.8)
      };
    }

    const line = resolveGovernanceLine(product, best.family);
    const area = line?.area || best.family.area || '';
    const confidence = Math.min(best.score / 5, 1);
    return {
      status: confidence >= 0.8 ? 'classified' : 'suggested',
      label: confidence >= 0.8 ? 'Classificato' : 'Suggerito',
      family: best.family.display_name,
      familyId: best.family.family_id,
      area,
      source: 'registry',
      confidence,
      line: line?.display_name || ''
    };
  }

  function findGovernanceOverride(product) {
    const skuKey = normalizeKey(product.sku);
    if (!skuKey) return null;
    return (state.governance.overrides?.overrides || []).find((override) => (
      normalizeKey(override.sku || override.variant_sku) === skuKey && normalizeKey(override.status || 'active') !== 'inactive'
    )) || null;
  }

  function scoreGovernanceFamily(product, entry) {
    const vendorKey = normalizeKey(product.vendor);
    const titleKey = normalizeKey(product.title);
    const lineKey = normalizeKey(product.line);
    const collectionKey = normalizeKey(product.collection);
    const tagKeys = (product.tags || []).map(normalizeKey);
    const vendorMatches = !entry.supplierKeys.length || entry.supplierKeys.includes(vendorKey);
    if (!vendorMatches && vendorKey) return { family: entry.family, score: 0 };

    let score = vendorMatches ? 1 : 0;
    entry.aliasKeys.forEach((aliasKey) => {
      if (!aliasKey) return;
      if (lineKey === aliasKey || collectionKey === aliasKey) score += 3;
      else if (titleKey === aliasKey) score += 3;
      else if (lineKey.includes(aliasKey) || collectionKey.includes(aliasKey)) score += 2;
      else if (titleKey.includes(aliasKey)) score += 2;
      else if (tagKeys.some((tagKey) => tagKey === aliasKey || tagKey.includes(aliasKey))) score += 1;
    });

    return { family: entry.family, score };
  }

  function resolveGovernanceLine(product, family) {
    const textKeys = [
      product.title,
      product.line,
      product.collection,
      ...(product.tags || [])
    ].map(normalizeKey).filter(Boolean);

    return (family.lines || []).find((line) => {
      const lineAliases = uniqueKeys([line.display_name, ...(line.aliases || [])]);
      return lineAliases.some((aliasKey) => textKeys.some((textKey) => textKey === aliasKey || textKey.includes(aliasKey)));
    }) || null;
  }

  function populateVendorFilter() {
    if (!els.catalogVendor) return;
    const vendors = Array.from(new Set(state.catalogProducts.map((product) => product.vendor).filter(Boolean))).sort();
    els.catalogVendor.innerHTML = '<option value="">Tutti</option>' + vendors.map((vendor) => (
      `<option value="${escapeHtml(vendor)}">${escapeHtml(vendor)}</option>`
    )).join('');
  }

  function renderCatalog() {
    const issueMap = buildCatalogIssueMap(state.catalogProducts);
    const search = getValue(els.catalogSearch).toLowerCase();
    const vendor = getValue(els.catalogVendor);
    const tag = getValue(els.catalogTag).toLowerCase();
    const issue = getValue(els.catalogIssue);

    state.catalogFiltered = state.catalogProducts.filter((product) => {
      const notes = issueMap.get(product) || [];
      const haystack = `${product.title} ${product.sku}`.toLowerCase();
      const tagsText = product.tags.join(',').toLowerCase();
      if (search && !haystack.includes(search)) return false;
      if (vendor && product.vendor !== vendor) return false;
      if (tag && !tagsText.includes(tag)) return false;
      if (!matchesCatalogIssue(product, notes, issue)) return false;
      return true;
    });

    renderCatalogStats(issueMap);
    renderGovernanceStats();
    renderCatalogRows(issueMap);
  }

  function buildCatalogIssueMap(products) {
    const skuCounts = countBy(products.map((product) => normalizeKey(product.sku)).filter(Boolean));
    const issueMap = new Map();
    products.forEach((product) => {
      const issues = [];
      if (!product.sku) issues.push(issue('missing_sku', 'Errore', 'SKU mancante'));
      if (!product.title) issues.push(issue('missing_title', 'Errore', 'Titolo mancante'));
      if (!product.price || product.price <= 0) issues.push(issue('missing_price', 'Errore', 'Prezzo assente o zero'));
      issues.push(...buildPriceIssues(product.rawPrice, product.price, ELS_CATALOG_RULES.priceWarnings));
      if (!product.preorder && !product.image) issues.push(issue('missing_image', 'Warning', 'Immagine assente per prodotto shop'));
      if (product.sku && skuCounts.get(normalizeKey(product.sku)) > 1) issues.push(issue('duplicate_sku', 'Errore', 'SKU duplicato'));
      if (product.vendor && !containsNormalized(ELS_CATALOG_RULES.allowedVendors, product.vendor)) issues.push(issue('unknown_vendor', 'Warning', 'Vendor non censito'));
      if (!hasAnyTag(product.tags, ELS_CATALOG_RULES.professionalTags)) issues.push(issue('missing_professional_tag', 'Warning', 'Tag professionale non rilevato'));
      const governance = getProductGovernance(product);
      if (governance.status === 'registry_missing') issues.push(issue('governance_registry_missing', 'Warning', 'Registry governance non disponibile'));
      if (governance.status === 'unclassified') issues.push(issue('governance_unclassified', 'Warning', 'Famiglia non classificata dal registry canonico'));
      if (governance.status === 'ambiguous') issues.push(issue('governance_ambiguous', 'Warning', 'Famiglia ambigua rispetto al registry canonico'));
      issueMap.set(product, issues);
    });
    return issueMap;
  }

  function matchesCatalogIssue(product, notes, issueName) {
    if (!issueName) return true;
    if (issueName === 'preorder') return product.preorder;
    if (issueName === 'shop') return !product.preorder;
    if (issueName === 'inactive') return !isActiveStatus(product.status);
    if (issueName === 'issues') return notes.length > 0;
    if (issueName === 'manual_override') return getProductGovernance(product).status === 'manual_override';
    return notes.some((note) => note.code === issueName);
  }

  function renderCatalogStats(issueMap) {
    if (!els.catalogStats) return;
    const products = state.catalogProducts;
    const withIssues = products.filter((product) => (issueMap.get(product) || []).length > 0);
    const stats = [
      ['Totale prodotti', products.length],
      ['Preordine', products.filter((product) => product.preorder).length],
      ['Attivi', products.filter((product) => isActiveStatus(product.status)).length],
      ['Con anomalie', withIssues.length]
    ];
    els.catalogStats.innerHTML = stats.map(renderStat).join('');
  }

  function renderGovernanceStats() {
    if (!els.governanceStats) return;
    const products = state.catalogProducts;
    const values = products.map(getProductGovernance);
    const registryFamilies = state.governance.registry?.families?.length || 0;
    const stats = [
      ['Registry canonico', state.governance.loadState === 'ready' ? `${registryFamilies} famiglie` : 'non disponibile'],
      ['Classificati', values.filter((item) => item.status === 'classified' || item.status === 'suggested').length],
      ['Override manuali', values.filter((item) => item.status === 'manual_override').length],
      ['Ambigui / unclassified', values.filter((item) => item.status === 'ambiguous' || item.status === 'unclassified').length]
    ];
    els.governanceStats.innerHTML = stats.map(renderStat).join('');
  }

  function renderCatalogRows(issueMap) {
    if (!els.catalogBody) return;
    if (!state.catalogFiltered.length) {
      els.catalogBody.innerHTML = '<tr><td colspan="11">Nessun prodotto trovato con i filtri attuali.</td></tr>';
      return;
    }
    els.catalogBody.innerHTML = state.catalogFiltered.slice(0, 300).map((product) => {
      const notes = issueMap.get(product) || [];
      const governance = getProductGovernance(product);
      const status = notes.some((item) => item.level === 'Errore') ? 'error' : (notes.length ? 'warning' : 'ok');
      return `<tr class="catalogo-dashboard__row--${status}">
        <td>${renderStatus(status)}</td>
        <td>${renderDestination(product.preorder, false)}</td>
        <td><strong>${escapeHtml(product.title || 'Senza titolo')}</strong><br><small>${escapeHtml(product.collection || 'Collezione non rilevata')} · ${escapeHtml(product.line || 'Linea non rilevata')}</small></td>
        <td>${escapeHtml(product.sku || '—')}</td>
        <td>${escapeHtml(product.vendor || '—')}</td>
        <td>${renderGovernanceCell(governance)}</td>
        <td>${formatCurrency(product.price)}</td>
        <td>${renderTags(product.tags)}</td>
        <td>${renderImageState(product)}</td>
        <td>${product.preorder ? 'Sì' : 'No'}</td>
        <td class="catalogo-dashboard__notes">${renderIssues(notes)}</td>
      </tr>`;
    }).join('');
  }

  function readCsvFile(file) {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const parsed = parseCsv(String(reader.result || ''), { fileName: file.name || '' });
        state.csvHeaders = parsed.headers;
        state.csvRows = parsed.rows;
        state.csvSourceName = file.name || '';
        state.csvDelimiter = parsed.delimiter || ',';
        state.csvValidated = validateCsvRows(parsed.headers, parsed.rows);
        renderCsv();
      } catch (error) {
        state.csvHeaders = [];
        state.csvRows = [];
        state.csvValidated = [];
        state.csvSourceName = file.name || '';
        state.csvDelimiter = ',';
        renderCsvError(error.message || 'CSV non valido');
      }
    };
    reader.readAsText(file);
  }

  function parseCsv(text, options = {}) {
    const rows = [];
    let row = [];
    let field = '';
    let inQuotes = false;
    const delimiter = detectCsvDelimiter(text);
    const normalizedText = String(text || '').replace(/^\uFEFF/, '');

    for (let index = 0; index < normalizedText.length; index += 1) {
      const char = normalizedText[index];
      const next = normalizedText[index + 1];
      if (inQuotes) {
        if (char === '"' && next === '"') {
          field += '"';
          index += 1;
        } else if (char === '"') {
          inQuotes = false;
        } else {
          field += char;
        }
      } else if (char === '"') {
        inQuotes = true;
      } else if (char === delimiter) {
        row.push(field);
        field = '';
      } else if (char === '\n') {
        row.push(field);
        rows.push(row);
        row = [];
        field = '';
      } else if (char !== '\r') {
        field += char;
      }
    }

    if (field || row.length) {
      row.push(field);
      rows.push(row);
    }

    const headerIndex = findCsvHeaderIndex(rows);
    const headers = (rows[headerIndex] || []).map(cleanCsvHeader);
    if (!headers.length) throw new Error('Intestazioni CSV assenti');

    const rawDataRows = rows.slice(headerIndex + 1)
      .filter((items) => items.some((item) => String(item || '').trim()))
      .map((items) => buildCsvRecord(headers, items));

    return normalizeCsvRecords(headers, rawDataRows, {
      delimiter,
      fileName: options.fileName || ''
    });
  }

  function detectCsvDelimiter(text) {
    const sample = String(text || '').split(/\r?\n/).slice(0, 10).join('\n');
    const delimiters = [',', ';', '\t', '|'];
    const scores = delimiters.map((delimiter) => {
      const count = sample.split('\n').reduce((total, line) => total + countDelimiterOutsideQuotes(line, delimiter), 0);
      return { delimiter, count };
    }).sort((a, b) => b.count - a.count);
    return scores[0]?.count ? scores[0].delimiter : ',';
  }

  function countDelimiterOutsideQuotes(line, delimiter) {
    let count = 0;
    let inQuotes = false;
    for (let index = 0; index < line.length; index += 1) {
      const char = line[index];
      const next = line[index + 1];
      if (char === '"' && next === '"') {
        index += 1;
      } else if (char === '"') {
        inQuotes = !inQuotes;
      } else if (!inQuotes && char === delimiter) {
        count += 1;
      }
    }
    return count;
  }

  function findCsvHeaderIndex(rows) {
    const index = rows.findIndex((row) => {
      const canonicalHits = row.map(cleanCsvHeader).filter((header) => resolveCanonicalCsvHeader(header)).length;
      const filled = row.filter((cell) => String(cell || '').trim()).length;
      return canonicalHits >= 2 || filled >= 4;
    });
    return index >= 0 ? index : 0;
  }

  function cleanCsvHeader(header) {
    return String(header || '').replace(/^\uFEFF/, '').replace(/\s+/g, ' ').trim();
  }

  function buildCsvRecord(headers, items) {
    const record = {};
    headers.forEach((header, index) => {
      const key = header || `Extra ${index + 1}`;
      record[key] = items[index] || '';
    });
    return record;
  }

  function normalizeCsvRecords(rawHeaders, rawRows, options) {
    const headerTargets = rawHeaders.map((header, index) => ({
      raw: header || `Extra ${index + 1}`,
      target: resolveCanonicalCsvHeader(header) || header || `Extra ${index + 1}`
    }));
    const defaultVendor = inferVendorFromFilename(options.fileName);
    const hasVendor = headerTargets.some((item) => item.target === ELS_PREIMPORT_RULES.vendorField);
    const sourceTags = inferTagsFromFilename(options.fileName);
    const headers = buildCanonicalCsvHeaders(headerTargets, Boolean(defaultVendor && !hasVendor), sourceTags.length > 0);
    const rows = rawRows.map((rawRow) => {
      const row = {};
      headerTargets.forEach(({ raw, target }) => {
        const value = String(rawRow[raw] || '').trim();
        if (!value) return;
        if (target === ELS_PREIMPORT_RULES.priceField && isVatIncludedPriceHeader(raw)) {
          row[target] = formatShopifyPrice(parsePrice(value) / 1.22);
          row['Variant Compare At Price'] = formatShopifyPrice(parsePrice(value));
          return;
        }
        if (target === 'Cost per item') {
          row[target] = formatShopifyPrice(parsePrice(value));
          return;
        }
        if (row[target]) {
          row[target] = `${row[target]}, ${value}`;
        } else {
          row[target] = value;
        }
      });
      if (defaultVendor && !row[ELS_PREIMPORT_RULES.vendorField]) {
        row[ELS_PREIMPORT_RULES.vendorField] = defaultVendor;
      }
      if (sourceTags.length) {
        const tags = normalizeTags(row[ELS_PREIMPORT_RULES.tagField]);
        sourceTags.forEach((tag) => {
          if (!hasTag(tags, tag)) tags.push(tag);
        });
        row[ELS_PREIMPORT_RULES.tagField] = tags.join(', ');
      }
      headers.forEach((header) => {
        if (row[header] === undefined) row[header] = '';
      });
      return row;
    });
    return { headers, rows, delimiter: options.delimiter || ',' };
  }

  function buildCanonicalCsvHeaders(headerTargets, includeVendor, includeTags) {
    const preferred = [
      ELS_PREIMPORT_RULES.titleField,
      ELS_PREIMPORT_RULES.skuField,
      ELS_PREIMPORT_RULES.priceField,
      ELS_PREIMPORT_RULES.vendorField,
      ELS_PREIMPORT_RULES.imageField,
      ELS_PREIMPORT_RULES.tagField,
      'Cost per item',
      'Variant Compare At Price'
    ];
    const seen = new Set();
    const headers = [];
    preferred.forEach((header) => {
      if (
        (includeVendor && header === ELS_PREIMPORT_RULES.vendorField) ||
        (includeTags && header === ELS_PREIMPORT_RULES.tagField) ||
        headerTargets.some((item) => item.target === header) ||
        (header === 'Variant Compare At Price' && headerTargets.some((item) => item.target === ELS_PREIMPORT_RULES.priceField && isVatIncludedPriceHeader(item.raw)))
      ) {
        headers.push(header);
        seen.add(header);
      }
    });
    headerTargets.forEach((item) => {
      if (!seen.has(item.target)) {
        headers.push(item.target);
        seen.add(item.target);
      }
    });
    return headers;
  }

  function resolveCanonicalCsvHeader(header) {
    const key = normalizeHeaderKey(header);
    if (!key) return '';
    return Object.entries(ELS_CSV_COLUMN_ALIASES).find(([, aliases]) => (
      aliases.some((alias) => normalizeHeaderKey(alias) === key)
    ))?.[0] || '';
  }

  function inferVendorFromFilename(fileName) {
    const key = normalizeHeaderKey(fileName);
    if (key.includes('take care') || key.includes('polyflame')) return 'Polyflame';
    if (key.includes('revivre')) return 'Revivre';
    if (key.includes('cpm')) return 'CPM';
    return '';
  }

  function inferTagsFromFilename(fileName) {
    const key = normalizeHeaderKey(fileName);
    const tags = [];
    if (key.includes('take care')) tags.push('take_care', 'collection_polyflame', 'brand_polyflame');
    if (key.includes('no disney')) tags.push('no_disney');
    if (key.includes('disney') && !key.includes('no disney')) tags.push('disney');
    return tags;
  }

  function isVatIncludedPriceHeader(header) {
    const key = normalizeHeaderKey(header);
    return key.includes('ttc') || key.includes('iva inclusa');
  }

  function validateCsvRows(headers, rows) {
    const skuField = ELS_PREIMPORT_RULES.skuField;
    const titleField = ELS_PREIMPORT_RULES.titleField;
    const rowContexts = buildShopifyCsvContexts(rows);
    const skuCounts = countBy(rows.map((row) => normalizeKey(row[skuField])).filter(Boolean));
    const titleCounts = countBy(rows.filter((row) => getRowValue(row, titleField)).map((row) => normalizeKey(row[titleField])).filter(Boolean));

    return rows.map((row, index) => {
      const context = rowContexts[index] || {};
      const sku = getRowValue(row, ELS_PREIMPORT_RULES.skuField);
      const title = getRowValue(row, ELS_PREIMPORT_RULES.titleField) || context.title || '';
      const vendor = getRowValue(row, ELS_PREIMPORT_RULES.vendorField) || context.vendor || '';
      const rawPrice = getRowValue(row, ELS_PREIMPORT_RULES.priceField);
      const price = parsePrice(rawPrice);
      const image = getRowValue(row, ELS_PREIMPORT_RULES.imageField) || context.image || '';
      const tags = normalizeTags(getRowValue(row, ELS_PREIMPORT_RULES.tagField) || context.tags || '');
      const isProductRow = Boolean(getRowValue(row, ELS_PREIMPORT_RULES.titleField));

      const suggestedPreorder = suggestPreorder(row, tags);
      const issues = buildCsvIssues({
        headers,
        row,
        isProductRow,
        sku,
        title,
        vendor,
        rawPrice,
        price,
        image,
        tags,
        preorder: suggestedPreorder,
        skuCounts,
        titleCounts
      });
      const status = resolveCsvStatus(issues);

      return {
        index,
        row,
        isProductRow,
        sku,
        title,
        vendor,
        rawPrice,
        price,
        tags,
        image,
        issues,
        status,
        preorder: suggestedPreorder,
        suggestedPreorder,
        preorderOverridden: false
      };
    });
  }

  function buildShopifyCsvContexts(rows) {
    const handleImage = new Map();
    rows.forEach((row) => {
      const handle = getRowValue(row, 'Handle');
      const image = getRowValue(row, ELS_PREIMPORT_RULES.imageField);
      if (handle && image && !handleImage.has(handle)) handleImage.set(handle, image);
    });

    const currentByHandle = new Map();
    let lastContext = {};
    return rows.map((row) => {
      const handle = getRowValue(row, 'Handle');
      const own = {
        title: getRowValue(row, ELS_PREIMPORT_RULES.titleField),
        vendor: getRowValue(row, ELS_PREIMPORT_RULES.vendorField),
        tags: getRowValue(row, ELS_PREIMPORT_RULES.tagField),
        image: getRowValue(row, ELS_PREIMPORT_RULES.imageField) || (handle ? handleImage.get(handle) : '')
      };

      const previous = handle ? (currentByHandle.get(handle) || {}) : lastContext;
      const context = {
        title: own.title || previous.title || '',
        vendor: own.vendor || previous.vendor || '',
        tags: own.tags || previous.tags || '',
        image: own.image || previous.image || ''
      };

      if (handle) currentByHandle.set(handle, context);
      lastContext = context;
      return context;
    });
  }

  function buildCsvIssues(context) {
    const { headers, isProductRow, sku, title, vendor, rawPrice, price, image, tags, skuCounts, titleCounts } = context;
    const issues = [];
    const missingHeaders = ELS_PREIMPORT_RULES.requiredFields.filter((field) => !headers.includes(field));
    missingHeaders.forEach((field) => issues.push(issue('missing_column', 'Errore', `Colonna obbligatoria assente: ${field}`)));

    if (!sku) issues.push(issue('missing_sku', 'Errore', 'SKU mancante'));
    if (!title) issues.push(issue('missing_title', 'Errore', 'Titolo mancante'));
    if (!price || price <= 0) issues.push(issue('missing_price', 'Errore', 'Prezzo assente o zero'));
    issues.push(...buildPriceIssues(rawPrice, price, ELS_PREIMPORT_RULES.priceWarnings));
    if (isProductRow && !image) issues.push(issue('missing_image', 'Warning', 'Immagine assente per prodotto shop'));
    if (sku && skuCounts.get(normalizeKey(sku)) > 1) issues.push(issue('duplicate_sku', 'Errore', 'SKU duplicato nel CSV'));
    if (isProductRow && title && titleCounts.get(normalizeKey(title)) > 1) issues.push(issue('duplicate_title', 'Warning', 'Titolo duplicato o sospetto'));
    if (vendor && !containsNormalized(ELS_PREIMPORT_RULES.allowedVendors, vendor)) issues.push(issue('unknown_vendor', 'Warning', 'Vendor non censito'));
    ELS_PREIMPORT_RULES.requiredTags.forEach((tag) => {
      if (!hasTag(tags, tag)) issues.push(issue('missing_required_tag', 'Errore', `Tag richiesto assente: ${tag}`));
    });
    return issues;
  }

  function refreshCsvItemStatus(item) {
    const skuCounts = countBy(state.csvValidated.map((entry) => normalizeKey(entry.sku)).filter(Boolean));
    const titleCounts = countBy(state.csvValidated.filter((entry) => entry.isProductRow).map((entry) => normalizeKey(entry.title)).filter(Boolean));
    item.issues = buildCsvIssues({
      headers: state.csvHeaders,
      row: item.row,
      isProductRow: item.isProductRow,
      sku: item.sku,
      title: item.title,
      vendor: item.vendor,
      rawPrice: item.rawPrice,
      price: item.price,
      image: item.image,
      tags: item.tags,
      preorder: item.preorder,
      skuCounts,
      titleCounts
    });
    item.status = resolveCsvStatus(item.issues);
  }

  function resolveCsvStatus(issues) {
    const hasBlockingError = issues.some((item) => item.level === 'Errore' && ELS_PREIMPORT_RULES.blockingErrors.includes(item.code));
    return hasBlockingError ? 'error' : (issues.length ? 'warning' : 'ok');
  }

  function suggestPreorder(row, tags) {
    for (const rule of ELS_PREIMPORT_RULES.preorderRules) {
      if (rule.type === 'tag_contains' && tags.some((tag) => normalizeKey(tag).includes(normalizeKey(rule.value)))) {
        return Boolean(rule.suggest);
      }
      if (rule.type === 'vendor_equals' && normalizeKey(getRowValue(row, ELS_PREIMPORT_RULES.vendorField)) === normalizeKey(rule.value)) {
        return Boolean(rule.suggest);
      }
    }
    return Boolean(ELS_PREIMPORT_RULES.defaultPreorder);
  }

  function renderCsv() {
    renderCsvStats();
    renderCsvRows();
    const hasRows = state.csvValidated.length > 0;
    els.exportClean.disabled = !hasRows;
    els.exportErrors.disabled = !hasRows;
    els.clearCsv.disabled = !hasRows;
  }

  function renderCsvStats() {
    if (!els.csvStats) return;
    const rows = state.csvValidated;
    const stats = [
      ['Righe CSV', rows.length],
      ['OK', rows.filter((row) => row.status === 'ok').length],
      ['Warning', rows.filter((row) => row.status === 'warning').length],
      ['Errori bloccanti', rows.filter((row) => row.status === 'error').length],
      ['Separatore', state.csvDelimiter === '\t' ? 'tab' : state.csvDelimiter],
      ['Vendor default', inferVendorFromFilename(state.csvSourceName) || 'non rilevato']
    ];
    els.csvStats.innerHTML = stats.map(renderStat).join('');
  }

  function renderCsvRows() {
    if (!els.csvBody) return;
    if (!state.csvValidated.length) {
      els.csvBody.innerHTML = '<tr><td colspan="10">Carica un CSV per iniziare il controllo pre-import.</td></tr>';
      return;
    }
    els.csvBody.innerHTML = state.csvValidated.slice(0, 500).map((item) => (
      `<tr class="catalogo-dashboard__row--${item.status}">
        <td>${renderStatus(item.status)}</td>
        <td>${renderDestination(item.preorder, item.preorderOverridden, true)}</td>
        <td>
          <label class="catalogo-dashboard__toggle">
            <input type="checkbox" data-preorder-toggle="${item.index}" ${item.preorder ? 'checked' : ''}>
            <span>${item.preorder ? 'Sì' : 'No'}${item.preorderOverridden ? ' · manuale' : ' · suggerito'}</span>
          </label>
        </td>
        <td><strong>${escapeHtml(item.title || 'Senza titolo')}</strong></td>
        <td>${escapeHtml(item.sku || '—')}</td>
        <td>${escapeHtml(item.vendor || '—')}</td>
        <td>${formatCurrency(item.price)}</td>
        <td>${renderTags(item.tags)}</td>
        <td>${item.preorder && !item.image ? 'Non prevista' : (item.image ? 'Sì' : 'No')}</td>
        <td class="catalogo-dashboard__notes">${renderIssues(item.issues)}</td>
      </tr>`
    )).join('');

    els.csvBody.querySelectorAll('[data-preorder-toggle]').forEach((input) => {
      input.addEventListener('change', () => {
        const index = Number(input.getAttribute('data-preorder-toggle'));
        const row = state.csvValidated.find((item) => item.index === index);
        if (!row) return;
        row.preorder = input.checked;
        row.preorderOverridden = row.preorder !== row.suggestedPreorder;
        refreshCsvItemStatus(row);
        renderCsvRows();
        renderCsvStats();
      });
    });
  }

  function renderCsvError(message) {
    if (els.csvBody) els.csvBody.innerHTML = `<tr><td colspan="9">${escapeHtml(message)}</td></tr>`;
    if (els.csvStats) els.csvStats.innerHTML = '';
  }

  function exportCleanCsv() {
    const headers = ensureHeader(state.csvHeaders, ELS_PREIMPORT_RULES.tagField);
    const rows = state.csvValidated
      .filter((item) => item.status !== 'error')
      .map((item) => buildExportRow(item, true));
    downloadCsv('els-preimport-clean.csv', headers, rows);
  }

  function exportIssuesCsv() {
    const headers = state.csvHeaders.concat(['ELS Status', 'ELS Anomalie', 'ELS Preordine']);
    const rows = state.csvValidated
      .filter((item) => item.status !== 'ok')
      .map((item) => {
        const row = buildExportRow(item, false);
        row['ELS Status'] = item.status.toUpperCase();
        row['ELS Anomalie'] = item.issues.map((note) => note.message).join(' | ');
        row['ELS Preordine'] = item.preorder ? 'yes' : 'no';
        return row;
      });
    downloadCsv('els-preimport-anomalie.csv', headers, rows);
  }

  function buildExportRow(item, applyPreorderTag) {
    const row = { ...item.row };
    if (applyPreorderTag) {
      if (ELS_PREIMPORT_RULES.priceWarnings.normalizeExport && item.price > 0) {
        row[ELS_PREIMPORT_RULES.priceField] = formatShopifyPrice(item.price);
      }

      const tags = normalizeTags(row[ELS_PREIMPORT_RULES.tagField]);
      if (item.preorder && !hasTag(tags, ELS_PREIMPORT_RULES.preorderTag)) {
        tags.push(ELS_PREIMPORT_RULES.preorderTag);
      }
      if (!item.preorder) {
        const preorderKey = normalizeKey(ELS_PREIMPORT_RULES.preorderTag);
        row[ELS_PREIMPORT_RULES.tagField] = tags.filter((tag) => normalizeKey(tag) !== preorderKey).join(', ');
      } else {
        row[ELS_PREIMPORT_RULES.tagField] = tags.join(', ');
      }
    }
    return row;
  }

  function downloadCsv(filename, headers, rows) {
    const csv = [headers, ...rows.map((row) => headers.map((header) => row[header] || ''))]
      .map((items) => items.map(escapeCsvField).join(','))
      .join('\r\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }

  function ensureHeader(headers, field) {
    if (!field || headers.includes(field)) return headers;
    return headers.concat(field);
  }

  function clearCsvState() {
    state.csvHeaders = [];
    state.csvRows = [];
    state.csvValidated = [];
    state.csvSourceName = '';
    state.csvDelimiter = ',';
    if (els.csvFile) els.csvFile.value = '';
    renderCsv();
  }

  function readCompareFile(file) {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const parsed = parseCsv(String(reader.result || ''));
        state.compareHeaders = parsed.headers;
        state.compareRows = parsed.rows;
        buildAndRenderCompare();
      } catch (error) {
        state.compareHeaders = [];
        state.compareRows = [];
        state.compareReport = [];
        state.compareFiltered = [];
        renderCompareError(error.message || 'CSV non valido');
      }
    };
    reader.readAsText(file);
  }

  function buildAndRenderCompare() {
    state.compareReport = buildCompareReport(state.compareHeaders, state.compareRows, state.catalogProducts);
    populateCompareVendorFilter();
    renderCompare();
  }

  function buildCompareReport(headers, csvRows, catalogProducts) {
    const shopProducts = normalizeCompareShopRows(headers, csvRows);
    const shopBySku = indexBySku(shopProducts);
    const listinoBySku = indexBySku(catalogProducts);
    const allSkus = Array.from(new Set([...shopBySku.keys(), ...listinoBySku.keys()])).sort();

    return allSkus.map((skuKey) => {
      const shop = shopBySku.get(skuKey);
      const listino = listinoBySku.get(skuKey);
      return compareSku(skuKey, shop, listino);
    });
  }

  function normalizeCompareShopRows(headers, rows) {
    const requiredHeaders = [ELS_PREIMPORT_RULES.skuField, ELS_PREIMPORT_RULES.priceField];
    const missingHeaders = requiredHeaders.filter((field) => !headers.includes(field));
    if (missingHeaders.length) {
      throw new Error(`Colonne obbligatorie assenti nel CSV confronto: ${missingHeaders.join(', ')}`);
    }

    const contexts = buildShopifyCsvContexts(rows);
    return rows.map((row, index) => {
      const context = contexts[index] || {};
      const sku = getRowValue(row, ELS_PREIMPORT_RULES.skuField);
      const title = getRowValue(row, ELS_PREIMPORT_RULES.titleField) || context.title || '';
      const vendor = getRowValue(row, ELS_PREIMPORT_RULES.vendorField) || context.vendor || '';
      const rawPrice = getRowValue(row, ELS_PREIMPORT_RULES.priceField);
      const tags = normalizeTags(getRowValue(row, ELS_PREIMPORT_RULES.tagField) || context.tags || '');
      return {
        sku,
        title,
        vendor,
        rawPrice,
        price: parsePrice(rawPrice),
        tags,
        row
      };
    }).filter((product) => product.sku);
  }

  function indexBySku(products) {
    const map = new Map();
    products.forEach((product) => {
      const skuKey = normalizeKey(product.sku);
      if (!skuKey) return;
      const existing = map.get(skuKey);
      if (existing) {
        existing.duplicates = (existing.duplicates || 1) + 1;
        return;
      }
      map.set(skuKey, { ...product, duplicates: 1 });
    });
    return map;
  }

  function compareSku(skuKey, shop, listino) {
    const sku = shop?.sku || listino?.sku || skuKey;
    const issues = [];
    let status = 'ok';
    let label = 'OK';
    let action = 'Nessuna azione';

    if (!shop && listino) {
      status = 'create';
      label = 'DA CREARE';
      action = 'Creare o importare nello shop Shopify';
      issues.push(compareIssue('missing_shop', 'SKU presente nel listino preordine ma assente dallo shop'));
    } else if (shop && !listino) {
      status = 'only_shop';
      label = 'SOLO SHOP';
      action = 'Aggiungere al listino/preordine oppure escludere con regola';
      issues.push(compareIssue('missing_listino', 'SKU presente nello shop ma assente dal listino preordine'));
    } else if (shop && listino) {
      if (Math.abs((shop.price || 0) - (listino.price || 0)) > ELS_COMPARE_RULES.priceTolerance) {
        status = 'update';
        label = 'DA AGGIORNARE';
        action = 'Verificare prezzo tra shop e listino';
        issues.push(compareIssue('price_diff', `Prezzo diverso: shop ${formatCurrency(shop.price)} / listino ${formatCurrency(listino.price)}`));
      }
      if (normalizeKey(shop.vendor) !== normalizeKey(listino.vendor)) {
        if (status === 'ok') {
          status = 'review';
          label = 'VERIFICA';
          action = 'Allineare vendor o regola vendor';
        }
        issues.push(compareIssue('vendor_diff', `Vendor diverso: shop "${shop.vendor || 'vuoto'}" / listino "${listino.vendor || 'vuoto'}"`));
      }
      if (shop.title && listino.title && normalizeKey(shop.title) !== normalizeKey(listino.title)) {
        if (status === 'ok') {
          status = 'review';
          label = 'VERIFICA';
          action = 'Verificare titolo tra fonti';
        }
        issues.push(compareIssue('title_diff', 'Titolo diverso tra shop e listino'));
      }
    }

    if (shop?.duplicates > 1 || listino?.duplicates > 1) {
      if (status === 'ok') {
        status = 'review';
        label = 'VERIFICA';
        action = 'Risolvere duplicati SKU';
      }
      if (shop?.duplicates > 1) issues.push(compareIssue('duplicate_sku', `SKU duplicato nello shop: ${shop.duplicates} righe`));
      if (listino?.duplicates > 1) issues.push(compareIssue('duplicate_sku', `SKU duplicato nel listino: ${listino.duplicates} righe`));
    }

    const comment = buildCompareComment({ status, action, issues, shop, listino });

    return {
      sku,
      status,
      label,
      action,
      comment,
      shop,
      listino,
      issues
    };
  }

  function compareIssue(code, message) {
    return { code, message };
  }

  function buildCompareComment({ status, action, issues, shop, listino }) {
    if (!issues.length) return 'Allineato: nessuna azione necessaria.';

    const primary = issues[0]?.code || '';
    const hasMultiple = issues.length > 1;
    const extra = hasMultiple ? ` Casi aggiuntivi: ${issues.slice(1).map((item) => item.message).join(' · ')}` : '';

    switch (primary) {
      case 'missing_shop':
        return `Creare o importare nello shop Shopify partendo dal listino operativo.${extra}`;
      case 'missing_listino':
        return `Verificare se lo SKU va aggiunto al listino preordine o escluso con regola di governance.${extra}`;
      case 'price_diff':
        return `Allineare il prezzo Shopify al listino operativo e ricontrollare la coerenza.${extra}`;
      case 'vendor_diff':
        return `Verificare vendor e normalizzazione prima del prossimo sync.${extra}`;
      case 'title_diff':
        return `Uniformare il titolo tra shop e listino per evitare biforcazioni di linea.${extra}`;
      case 'duplicate_sku':
        return `Risolvere i duplicati SKU prima di procedere con nuove pubblicazioni.${extra}`;
      default:
        return `${action}.${extra}`;
    }
  }

  function renderCompare() {
    state.compareFiltered = filterCompareReport();
    renderCompareStats();
    renderCompareRows();
    updateCatalogWorkerControls();
    const hasRows = state.compareReport.length > 0;
    const hasFilteredRows = state.compareFiltered.length > 0;
    if (els.exportCompare) els.exportCompare.disabled = !hasFilteredRows;
    if (els.exportCompareCreate) els.exportCompareCreate.disabled = !state.compareReport.some((item) => item.status === 'create');
    if (els.exportCompareUpdate) els.exportCompareUpdate.disabled = !state.compareReport.some((item) => item.status === 'update');
    if (els.exportCompareOnlyShop) els.exportCompareOnlyShop.disabled = !state.compareReport.some((item) => item.status === 'only_shop');
    if (els.clearCompare) els.clearCompare.disabled = !hasRows;
  }

  function updateCatalogWorkerControls() {
    const hasRows = state.compareFiltered.length > 0;
    const hasUrl = Boolean(getValue(els.catalogWorkerUrl));
    const hasSecret = Boolean(getValue(els.catalogWorkerSecret));
    if (els.catalogWorkerPlan) els.catalogWorkerPlan.disabled = !(hasRows && hasUrl && hasSecret);
    if (els.exportCatalogPlan) els.exportCatalogPlan.disabled = !(state.catalogPlan?.plan || []).length;
  }

  function filterCompareReport() {
    const search = getValue(els.compareSearch).toLowerCase();
    const status = getValue(els.compareStatus);
    const vendor = getValue(els.compareVendor);
    const issueCode = getValue(els.compareIssue);

    return state.compareReport.filter((item) => {
      const haystack = [
        item.sku,
        item.shop?.title,
        item.listino?.title
      ].join(' ').toLowerCase();
      const itemVendors = [item.shop?.vendor, item.listino?.vendor].filter(Boolean);
      if (search && !haystack.includes(search)) return false;
      if (status === 'issues' && item.status === 'ok') return false;
      if (status && status !== 'issues' && item.status !== status) return false;
      if (vendor && !itemVendors.some((itemVendor) => normalizeKey(itemVendor) === normalizeKey(vendor))) return false;
      if (issueCode && !item.issues.some((note) => note.code === issueCode)) return false;
      return true;
    });
  }

  function populateCompareVendorFilter() {
    if (!els.compareVendor) return;
    const vendors = new Set();
    state.compareReport.forEach((item) => {
      if (item.shop?.vendor) vendors.add(item.shop.vendor);
      if (item.listino?.vendor) vendors.add(item.listino.vendor);
    });
    els.compareVendor.innerHTML = '<option value="">Tutti</option>' + Array.from(vendors).sort().map((vendor) => (
      `<option value="${escapeHtml(vendor)}">${escapeHtml(vendor)}</option>`
    )).join('');
  }

  function renderCompareStats() {
    if (!els.compareStats) return;
    const rows = state.compareReport;
    const filtered = state.compareFiltered;
    const issues = rows.flatMap((row) => row.issues);
    const stats = [
      ['SKU confrontati', rows.length],
      ['Visibili', filtered.length],
      ['Da creare', rows.filter((row) => row.status === 'create').length],
      ['Solo shop', rows.filter((row) => row.status === 'only_shop').length],
      ['Prezzi diversi', issues.filter((note) => note.code === 'price_diff').length],
      ['Vendor diversi', issues.filter((note) => note.code === 'vendor_diff').length],
      ['Titoli diversi', issues.filter((note) => note.code === 'title_diff').length],
      ['Duplicati SKU', issues.filter((note) => note.code === 'duplicate_sku').length],
      ['OK', rows.filter((row) => row.status === 'ok').length]
    ];
    els.compareStats.innerHTML = stats.map(renderStat).join('');
  }

  function renderCompareRows() {
    if (!els.compareBody) return;
    if (!state.compareReport.length) {
      els.compareBody.innerHTML = '<tr><td colspan="11">Carica un CSV Shopify per confrontarlo con il listino preordine.</td></tr>';
      return;
    }
    if (!state.compareFiltered.length) {
      els.compareBody.innerHTML = '<tr><td colspan="11">Nessuna riga trovata con i filtri attuali.</td></tr>';
      return;
    }

    const priority = { create: 1, update: 2, only_shop: 3, review: 4, ok: 5 };
    const rows = [...state.compareFiltered].sort((a, b) => (priority[a.status] || 9) - (priority[b.status] || 9));
    els.compareBody.innerHTML = rows.slice(0, 600).map((item) => (
      `<tr class="catalogo-dashboard__row--${getCompareRowTone(item.status)}">
        <td>${renderCompareStatus(item)}</td>
        <td>${escapeHtml(item.sku || '—')}</td>
        <td>${escapeHtml(item.shop?.title || '—')}</td>
        <td>${escapeHtml(item.listino?.title || '—')}</td>
        <td>${escapeHtml(item.shop?.vendor || '—')}</td>
        <td>${escapeHtml(item.listino?.vendor || '—')}</td>
        <td>${item.shop ? formatCurrency(item.shop.price) : '—'}</td>
        <td>${item.listino ? formatCurrency(item.listino.price) : '—'}</td>
        <td>${escapeHtml(item.action)}</td>
        <td class="catalogo-dashboard__comment">${escapeHtml(item.comment || 'Allineato')}</td>
        <td class="catalogo-dashboard__notes">${item.issues.length ? item.issues.map((note) => escapeHtml(note.message)).join('<br>') : 'Allineato'}</td>
      </tr>`
    )).join('');
  }

  function renderCompareError(message) {
    if (els.compareBody) els.compareBody.innerHTML = `<tr><td colspan="11">${escapeHtml(message)}</td></tr>`;
    if (els.compareStats) els.compareStats.innerHTML = '';
    if (els.exportCompare) els.exportCompare.disabled = true;
    if (els.exportCompareCreate) els.exportCompareCreate.disabled = true;
    if (els.exportCompareUpdate) els.exportCompareUpdate.disabled = true;
    if (els.exportCompareOnlyShop) els.exportCompareOnlyShop.disabled = true;
    if (els.clearCompare) els.clearCompare.disabled = true;
  }

  function exportCompareCsv() {
    exportCompareRows('els-confronto-fonti-filtrato.csv', state.compareFiltered);
  }

  function exportCompareSubset(status) {
    const filenameByStatus = {
      create: 'els-da-creare-shopify.csv',
      update: 'els-da-aggiornare-prezzi.csv',
      only_shop: 'els-solo-shop.csv'
    };
    exportCompareRows(filenameByStatus[status] || 'els-confronto-fonti.csv', state.compareReport.filter((item) => item.status === status));
  }

  function exportCompareRows(filename, reportRows) {
    const rows = reportRows
      .filter((item) => item.status !== 'ok')
      .map((item) => ({
        'ELS Stato': item.label,
        'SKU': item.sku,
        'Titolo shop': item.shop?.title || '',
        'Titolo listino': item.listino?.title || '',
        'Vendor shop': item.shop?.vendor || '',
        'Vendor listino': item.listino?.vendor || '',
        'Prezzo shop': item.shop ? formatShopifyPrice(item.shop.price) : '',
        'Prezzo listino': item.listino ? formatShopifyPrice(item.listino.price) : '',
        'Azione suggerita': item.action,
        'Commento operativo': item.comment || '',
        'Note': item.issues.map((note) => note.message).join(' | ')
      }));
    downloadCsv(filename, ELS_COMPARE_RULES.exportHeaders, rows);
  }

  async function runCatalogWorkerPlan() {
    const workerUrl = getValue(els.catalogWorkerUrl).replace(/\/+$/, '');
    const secret = getValue(els.catalogWorkerSecret);
    const items = state.compareFiltered
      .filter((item) => item.status !== 'ok')
      .slice(0, 250)
      .map((item) => buildCatalogWorkerItem(item));

    if (!workerUrl || !secret || !items.length) return;

    setCatalogWorkerStatus(`Verifica Shopify in corso su ${items.length} righe...`);
    if (els.catalogWorkerPlan) els.catalogWorkerPlan.disabled = true;

    try {
      const response = await fetch(`${workerUrl}/catalog/plan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-ELS-Catalog-Secret': secret
        },
        body: JSON.stringify({ items })
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload.ok) {
        throw new Error(payload.error || `HTTP ${response.status}`);
      }
      state.catalogPlan = payload;
      renderCatalogPlanResult(payload);
    } catch (error) {
      state.catalogPlan = null;
      setCatalogWorkerStatus(`Errore worker V3: ${error.message || error}`);
    } finally {
      updateCatalogWorkerControls();
    }
  }

  function buildCatalogWorkerItem(item) {
    const source = item.listino || item.shop || {};
    return {
      sku: item.sku,
      title: source.title || '',
      vendor: source.vendor || '',
      price: source.price || 0,
      tags: source.tags || [],
      preorder: Boolean(item.listino)
    };
  }

  function renderCatalogPlanResult(payload) {
    const summary = payload.summary || {};
    setCatalogWorkerStatus([
      `Piano Shopify dry-run: ${payload.count || 0} righe.`,
      `Da creare: ${summary.create || 0}.`,
      `Da rivedere: ${summary.updateReview || 0}.`,
      `Senza modifiche: ${summary.noChange || 0}.`,
      `Bloccate: ${summary.blocked || 0}.`
    ].join(' '));
  }

  function exportCatalogPlanCsv() {
    const plan = state.catalogPlan?.plan || [];
    const headers = ['Status', 'Azione', 'SKU', 'Titolo', 'Vendor', 'Prezzo', 'Preordine', 'Shopify product id', 'Shopify variant id', 'Motivi'];
    const rows = plan.map((item) => ({
      'Status': item.status || '',
      'Azione': item.action || '',
      'SKU': item.sku || '',
      'Titolo': item.title || item.shopify?.title || '',
      'Vendor': item.vendor || item.shopify?.vendor || '',
      'Prezzo': item.price ? formatShopifyPrice(item.price) : '',
      'Preordine': item.preorder ? 'yes' : 'no',
      'Shopify product id': item.shopify?.productId || '',
      'Shopify variant id': item.shopify?.variantId || '',
      'Motivi': (item.reasons || []).join(' | ')
    }));
    downloadCsv('els-piano-shopify-dry-run.csv', headers, rows);
  }

  function setCatalogWorkerStatus(message) {
    if (els.catalogWorkerStatus) els.catalogWorkerStatus.textContent = message;
  }

  function clearCompareState() {
    state.compareHeaders = [];
    state.compareRows = [];
    state.compareReport = [];
    state.compareFiltered = [];
    state.catalogPlan = null;
    if (els.compareFile) els.compareFile.value = '';
    if (els.compareSearch) els.compareSearch.value = '';
    if (els.compareStatus) els.compareStatus.value = '';
    if (els.compareVendor) els.compareVendor.innerHTML = '<option value="">Tutti</option>';
    if (els.compareIssue) els.compareIssue.value = '';
    setCatalogWorkerStatus('Worker V3 non ancora interrogato.');
    renderCompare();
  }

  function renderStat(item) {
    return `<article class="catalogo-dashboard__stat"><span>${escapeHtml(item[0])}</span><strong>${escapeHtml(String(item[1]))}</strong></article>`;
  }

  function renderStatus(status) {
    const label = status === 'error' ? 'ERRORE' : status === 'warning' ? 'WARNING' : status === 'ok' ? 'OK' : 'INFO';
    return `<span class="catalogo-dashboard__status catalogo-dashboard__status--${status || 'neutral'}">${label}</span>`;
  }

  function renderCompareStatus(item) {
    return `<span class="catalogo-dashboard__status catalogo-dashboard__status--${getCompareRowTone(item.status)}">${escapeHtml(item.label)}</span>`;
  }

  function getCompareRowTone(status) {
    if (status === 'ok') return 'ok';
    if (status === 'create' || status === 'update') return 'warning';
    if (status === 'only_shop' || status === 'review') return 'neutral';
    return 'neutral';
  }

  function renderTags(tags) {
    const visible = (tags || []).slice(0, 5);
    if (!visible.length) return '—';
    return `<div class="catalogo-dashboard__tag-list">${visible.map((tag) => `<span class="catalogo-dashboard__tag">${escapeHtml(tag)}</span>`).join('')}</div>`;
  }

  function renderDestination(isPreorder, isManual, includeShop) {
    const label = includeShop
      ? (isPreorder ? 'Shop + Preordine' : 'Shop')
      : (isPreorder ? 'Preordine' : 'Shop');
    const suffix = isManual ? ' · manuale' : '';
    return `<span class="catalogo-dashboard__badge">${label}${suffix}</span>`;
  }

  function renderGovernanceCell(governance) {
    const tone = getGovernanceTone(governance.status);
    const confidence = Math.round((governance.confidence || 0) * 100);
    const family = governance.family || 'Da rivedere';
    const area = governance.area || 'area non assegnata';
    const line = governance.line ? ` · ${governance.line}` : '';
    return `<span class="catalogo-dashboard__status catalogo-dashboard__status--${tone}">${escapeHtml(governance.label || 'Governance')}</span><br><small>${escapeHtml(family)} · ${escapeHtml(area)}${escapeHtml(line)} · ${confidence}%</small>`;
  }

  function getGovernanceTone(status) {
    if (status === 'classified' || status === 'manual_override') return 'ok';
    if (status === 'suggested' || status === 'ambiguous') return 'warning';
    if (status === 'unclassified' || status === 'registry_missing') return 'neutral';
    return 'neutral';
  }

  function getProductGovernance(product) {
    return state.governance.productMap.get(product) || {
      status: 'registry_missing',
      label: 'Registry assente',
      family: '',
      area: '',
      source: 'none',
      confidence: 0
    };
  }

  function renderImageState(product) {
    if (product.preorder && !product.image) return 'Non prevista';
    return product.image ? 'Sì' : 'No';
  }

  function renderIssues(issues) {
    if (!issues.length) return 'Nessuna anomalia';
    return issues.map((item) => `${item.level}: ${escapeHtml(item.message)}`).join('<br>');
  }

  function issue(code, level, message) {
    return { code, level, message };
  }

  function getRowValue(row, field) {
    return String(row[field] || '').trim();
  }

  function getValue(input) {
    return String(input?.value || '').trim();
  }

  function parsePrice(value) {
    if (typeof value === 'number') return value;
    let normalized = String(value || '')
      .replace('€', '')
      .replace(/\s/g, '')
      .trim();

    if (!normalized) return 0;

    const lastComma = normalized.lastIndexOf(',');
    const lastDot = normalized.lastIndexOf('.');

    if (lastComma >= 0 && lastDot >= 0) {
      const decimalSeparator = lastComma > lastDot ? ',' : '.';
      const thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
      normalized = normalized
        .replace(new RegExp(`\\${thousandsSeparator}`, 'g'), '')
        .replace(decimalSeparator, '.');
    } else if (lastComma >= 0) {
      normalized = normalized.replace(',', '.');
    } else if (lastDot >= 0) {
      normalized = normalized;
    }

    const parsed = Number.parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function buildPriceIssues(rawValue, parsedPrice, rules) {
    const raw = String(rawValue ?? '').replace('€', '').replace(/\s/g, '').trim();
    const issues = [];
    if (!raw || !parsedPrice || parsedPrice <= 0) return issues;

    const decimalPlaces = getDecimalPlaces(raw);
    if (decimalPlaces > rules.maxDecimalPlaces) {
      issues.push(issue('price_decimal_precision', 'Warning', `Prezzo con più di ${rules.maxDecimalPlaces} decimali: verrà normalizzato nel CSV pulito`));
    }

    if (parsedPrice >= rules.highPrice) {
      issues.push(issue('high_price', 'Warning', `Prezzo alto o da verificare: ${formatCurrency(parsedPrice)}`));
    }

    return issues;
  }

  function getDecimalPlaces(rawValue) {
    const raw = String(rawValue || '').trim();
    const lastComma = raw.lastIndexOf(',');
    const lastDot = raw.lastIndexOf('.');
    const separatorIndex = Math.max(lastComma, lastDot);
    if (separatorIndex < 0) return 0;

    const separator = raw[separatorIndex];
    const otherSeparator = separator === ',' ? '.' : ',';
    const decimals = raw.slice(separatorIndex + 1);

    return decimals.length;
  }

  function formatCurrency(value) {
    const number = Number(value) || 0;
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(number);
  }

  function formatShopifyPrice(value) {
    const number = Number(value) || 0;
    return number.toFixed(2);
  }

  function normalizeTags(value) {
    if (Array.isArray(value)) return value.map((tag) => String(tag || '').trim()).filter(Boolean);
    return String(value || '').split(',').map((tag) => tag.trim()).filter(Boolean);
  }

  function hasTag(tags, expected) {
    const expectedKey = normalizeKey(expected);
    return tags.some((tag) => normalizeKey(tag) === expectedKey);
  }

  function hasAnyTag(tags, expectedTags) {
    return expectedTags.some((tag) => hasTag(tags, tag));
  }

  function containsNormalized(list, value) {
    const key = normalizeKey(value);
    return list.some((item) => normalizeKey(item) === key);
  }

  function isActiveStatus(value) {
    const key = normalizeKey(value);
    return ELS_CATALOG_RULES.statusActiveValues.some((status) => normalizeKey(status) === key);
  }

  function countBy(values) {
    const counts = new Map();
    values.forEach((value) => counts.set(value, (counts.get(value) || 0) + 1));
    return counts;
  }

  function uniqueKeys(values) {
    return Array.from(new Set((values || []).map(normalizeKey).filter(Boolean)));
  }

  function normalizeKey(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function normalizeHeaderKey(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/^\uFEFF/, '')
      .replace(/\s+/g, ' ')
      .replace(/\s*\/\s*/g, ' / ')
      .trim()
      .toLowerCase();
  }

  function slugify(value) {
    return normalizeKey(value).replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  }

  function escapeCsvField(value) {
    const text = String(value || '');
    if (/[",\r\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
    return text;
  }

  function setSourceState(text) {
    if (els.sourceState) els.sourceState.textContent = text;
  }

  function buildSourceState(sourceName) {
    const governanceLabel = state.governance.loadState === 'ready'
      ? `governance ${state.governance.registry?.families?.length || 0} famiglie`
      : 'governance non disponibile';
    return `Fonte dati: ${sourceName} · ${state.catalogProducts.length} righe · ${governanceLabel}`;
  }
})();
